export default "__VITE_ASSET__C0bDYwhI__"